import React from 'react';
import MobileIntegrationCode from "./MobileIntegrationCode";
import IntegrationCode from "./IntegrationCode";
import WebchatMobileIcon from '../../../../../../../../assets/icons/platforms/WebchatMobileIcon'
import WebchatIcon from '../../../../../../../../assets/icons/platforms/WebchatIcon'

/*
 * The web chat channel: the snippet for a page, and the one for a phone.
 *
 * It is laid out like every other channel now - one .bg-white panel, its
 * contents held to 1200px and centred - which is what Viber, WhatsApp, Telegram
 * and Webex all do. It had none: two bare .channel cards in a flex column, so
 * switching to this tab lost the surrounding panel that every neighbouring tab
 * has, and the page appeared to come apart.
 *
 * The two halves are sections inside that one panel rather than cards of their
 * own - a card holding cards is the box-in-box this file had before.
 */
const sectionHead = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
};

const iconStyle = {marginRight: '15px', color: 'var(--ds-fg-tertiary)'};

export const WebChat = ({client}) => {
    return (
        <div className="bg-white" style={{
            minHeight: 'auto',
            height: 'fit-content',
            maxHeight: '65vh',
            overflow: 'auto',
        }}>
            <div style={{width: '100%', height: '100%'}}>
                <div style={{maxWidth: '1200px', margin: '0 auto', paddingBottom:'16px'}}>

                    <div style={{minWidth: 0}}>
                        <div style={sectionHead}>
                            {/* the same drawn pair the bot testing buttons use */}
                            <WebchatIcon
                                width={32}
                                height={32}
                                strokeWidth={1.5}
                                stroke="currentColor"
                                style={iconStyle}
                            />
                            <h2>WebChat</h2>
                        </div>
                        <IntegrationCode client={client} commonStyles={{bottomMargin: '10px'}}/>
                    </div>

                    {/* the two snippets are separate things; the rule says so
                        without wrapping either of them in a box */}
                    <div style={{
                        height: '1px',
                        margin: '24px 0',
                        backgroundColor: 'var(--ds-border-secondary)',
                    }}/>

                    <div style={{minWidth: 0}}>
                        <div style={sectionHead}>
                            <WebchatMobileIcon
                                width={32}
                                height={32}
                                strokeWidth={1.5}
                                stroke="currentColor"
                                style={iconStyle}
                            />
                            <h2>WebChat (Mobile)</h2>
                        </div>
                        <MobileIntegrationCode client={client} commonStyles={{bottomMargin: '10px'}}/>
                    </div>

                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/integrations/components/WebChat.jsx